import { Form, Formik } from 'formik';
import React from 'react';
import { TextAreaGroup } from 'shared/formik/TextAreaGroup';
import { MutationErrors } from '../../../shared/components/MutationErrors';
import { PageContainer } from 'shared/components/PageContainer';
import { RentalPageTitleHelmet } from 'rental/components/PageTitleHelmet';
import { SubmitActions } from '../../../shared/components/SubmitActions';
import { PageHeading } from 'shared/components/typography';
import { AdditionalInfoFragment, App_ApplicationFragment, App_PortalFragment, useAdditionalInfoQuery, useUpdateCustomerMutation } from '../../generated.graphql';
import { getSubmitActionsProps } from 'shared/forms/helpers';
import { RentalStepProps } from 'rental/app/steps';

interface Props extends RentalStepProps {
  application: App_ApplicationFragment
  portal: App_PortalFragment
}

export const AdditionalInfo = (props: Props) => {
  const [queryResult,] = useAdditionalInfoQuery({variables: {portalSlug: props.portal.slug}})
  const [, executeMutation] = useUpdateCustomerMutation();
  const initialData = queryResult.data?.portal?.myApplication?.customer;
  return (
    <PageContainer>
      <RentalPageTitleHelmet>Anything else?</RentalPageTitleHelmet>
      <PageHeading>Anything else we need to know?</PageHeading>
      {initialData &&
        <Formik<AdditionalInfoFragment>
          initialValues={initialData}
          onSubmit={async (values, formikHelpers) => {

            const r = await executeMutation({
              input: {
                portalSlug: props.portal.slug,
                workComments: values.workComments,
              }
            });

            if (r.data?.updateCustomer?.application) {
              props.onSubmitSuccessful();
            }
            else {
              formikHelpers.setStatus(r.data?.updateCustomer?.errors || null)
              props.onSubmitFailure();
            }
          }}
        >
          {formik => 
            <Form noValidate>
              {formik.status && <MutationErrors errors={formik.status}/>}
              <div className="my-4">
                <div className="form-row">
                  <TextAreaGroup 
                    label="Optional additional comments" 
                    placeholder={"Optional additional comments.  \n\nFor example: I'm going to return my existing rental item once this one gets approved."}
                    name="workComments" 
                    className="col-sm" 
                    rows={8} 
                  />
                </div>
              </div>

              <SubmitActions {...getSubmitActionsProps(formik, props)}/>

            </Form>
          }
      </Formik>
    }
    </PageContainer>
  );
}